import { PDF_DOCUMENT_OPTIONS } from 'core/modules/components/pdfViewers/pdfDocumentOptions';
import PropTypes from 'prop-types';
import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

const TwoPagePdfViewer = ({ url, page, onDocumentLoadSuccess, numPages }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  return (
    <div className="two-page-pdf-viewer">
      <Document
        file={{ url: url, headers: { 'Access-Control-Allow-Origin': '*' } }}
        onLoadSuccess={onDocumentLoadSuccess}
        options={PDF_DOCUMENT_OPTIONS}
        pageLayout={'oneColumn'}
        className={'two-page-pdf-viewer__document'}
      >
        <Page
          pageNumber={page}
          renderAnnotationLayer={false}
          className={`'two-page-pdf-viewer__page' ${numPages > 1} ? : 'two-page-pdf-viewer__page-two-pages' : 'two-page-pdf-viewer__page-one-page'}`}
        />
      </Document>
    </div>
  );
};

TwoPagePdfViewer.propTypes = {
  numPages: PropTypes.number,
  onDocumentLoadSuccess: PropTypes.func,
  page: PropTypes.number,
  url: PropTypes.string,
};

export default TwoPagePdfViewer;
